'use strict';

var React = require('react');
require('prop-types');
var classNames = require('classnames');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var CurrencyDisplay = require('../CurrencyDisplay.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = function styles(theme) {
  return {
    wrapper: {
      padding: '8px 0px',
      cursor: 'pointer'
    },
    notSelected: {
      '&:hover': {
        borderStyle: 'solid',
        borderWidth: 1,
        borderRadius: 8,
        borderColor: theme.palette.divider
      }
    },
    selected: {
      borderStyle: 'solid',
      borderWidth: 1,
      borderRadius: 8,
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.white.primary
    },
    textColorSelected: {
      color: theme.palette.primary.main
    },
    textColorNotSelected: {
      color: theme.palette.secondary.light
    }
  };
};

var BillingCycleOption = function BillingCycleOption(_ref) {
  var classes = _ref.classes,
      paymentOption = _ref.paymentOption,
      currentOption = _ref.currentOption,
      selectedOption = _ref.selectedOption,
      handleClick = _ref.handleClick,
      showValue = _ref.showValue;
  var isSelected = selectedOption === currentOption;
  return React__default["default"].createElement("div", {
    className: classNames__default["default"](classes.wrapper, isSelected ? classes.selected : classes.notSelected),
    onClick: function onClick() {
      return handleClick(currentOption);
    }
  }, showValue && React__default["default"].createElement(Typography, {
    variant: "subtitle1",
    align: "center",
    className: isSelected ? classes.textColorSelected : classes.textColorNotSelected
  }, React__default["default"].createElement(CurrencyDisplay, {
    amountInCents: paymentOption.value
  })), React__default["default"].createElement(Typography, {
    variant: "caption",
    align: "center",
    className: isSelected ? classes.textColorSelected : classes.textColorNotSelected
  }, paymentOption.label));
};

BillingCycleOption.defaultProps = {
  showValue: true
};
var BillingCycleOption$1 = withStyles(styles)(BillingCycleOption);

module.exports = BillingCycleOption$1;
